"use client";

import { Construction } from "lucide-react";

export function UnderConstruction() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Main Content Container - Match UnifiedMessaging sizing */}
      <div className="w-full md:max-w-2xl">
        <div className="flex items-start justify-center p-4 pt-32">
          <div className="flex flex-col items-center gap-4 text-center">
            <Construction
              className="h-16 w-16 animate-bounce text-primary"
              strokeWidth={1.5}
            />
            <p className="text-lg text-gray-700 dark:text-gray-300">
              This page is currently under construction
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
